import React, {
  ComponentType
} from 'react'
import { Divider } from 'semantic-ui-react'
// Local
import EncounterAppointment from '../common/encounterAppointment'
import EncounterPatient from '../common/encounterPatient'
import EncounterPractitioner from '../common/encounterPractitioner'
import EncounterProfile from '../common/encounterProfile'
import EncounterReason from '../common/encounterReason'
import EncounterReviewer from '../common/encounterReviewer'
import EncounterReviewWarning from '../common/encounterReviewWarning'
import { EncounterDetail } from '../../authenticated/types'
import { shouldRenderReskin2025 } from '../../../constant'
import If from '../../common/if'

const SafeDivider = Divider as unknown as ComponentType<any>

type ClinicalAdminEncounterLeftProps = {
  encounterDetail: EncounterDetail
}

/**
 * Provides a component that renders the Clinical Admin encounter left content
 * @param encounterDetail Encounter detail entity
 */
function ClinicalAdminEncounterLeft(
  props: ClinicalAdminEncounterLeftProps
): JSX.Element {
  const { encounterDetail } = props
  const { encounter } = encounterDetail
  const review = encounter && encounter.review
    ? encounter.review
    : null

  return (
    <div>
      <SafeDivider className="green-border" />
      <EncounterReviewWarning
        mode="left"
        review={ review }
      />
      <If isTrue={ !!encounter }>
        <>
          <EncounterProfile
            mode="left"
            encounter={ encounter }
          />
          <If isTrue={ shouldRenderReskin2025 }>
            <div className="profile-divider" />
          </If>
          <EncounterPatient
            mode="left"
            encounter={ encounter }
          />
          <EncounterReason
            mode="left"
            encounter={ encounter }
          />
          <EncounterAppointment
            mode="left"
            encounter={ encounter }
          />
          <EncounterPractitioner
            mode="left"
            encounter={ encounter }
          />
        </>
      </If>
      <EncounterReviewer
        mode="left"
        review={ review }
      />
    </div>
  )
}

export default ClinicalAdminEncounterLeft
